export default {"src":"/_next/static/media/legalOutline75_40.e1593d42.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};